import { JSONSchema6 } from "json-schema";

const finalizeCheckoutSessionSchema: JSONSchema6 = {
    title: "FinalizeCheckoutSession",
    description: "Finalize Checkout Session after your onCompleteCheckout event handler was invoked to finalize the paymentIntent. The chargeAmount in the request must match the Checkout Session object paymentDetails.chargeAmount to verify order amount. You must also specify totalOrderAmount and supplementaryData if one was provided for the Checkout Session. For PayAndShip use cases, the shippingAddress is also required and must match the address shared by Amazon. For PayOnly use cases, the same requirement exists for the billingAddress. Note : Finalize Checkout Session is only required for an Amazon Pay Buy Now integration. If you are integrating any other checkout or payment flow, please use Complete Checkout Session.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-simulation-code": {
                    title: "x-amz-pay-simulation-code",
                    type: "string"
                }
            },
            required: []
        },
        "pathParam": {
            title: "checkoutSessionId",
            type: "string"
        },
        "payload": {
            type: "object",
            properties: {
                "paymentIntent": {
                    type: "string",
                    enum: ["Confirm", "Authorize", "AuthorizeWithCapture"]
                },
                "chargeAmount": {
                    type: "object",
                    description: "Transaction amount",
                    properties: {
                        "amount": {
                        type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    },
                    required: ["amount", "currencyCode"]
                },
                "totalOrderAmount": {
                    type: "object",
                    description: "Transaction amount",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    }
                },
                "canHandlePendingAuthorization": {
                    type: "boolean"
                },
                "supplementaryData": {
                    type: "string"
                },
                "shippingAddress": {
                    type: "object",
                    properties: {
                        name: {
                            type: "string",
                        },
                        addressLine1: {
                            type: "string",
                        },
                        addressLine2: {
                            type: "string",
                        },
                        addressLine3: {
                            type: "string",
                        },
                        city: {
                            type: "string",
                        },
                        county: {
                            type: "string",
                        },
                        district: {
                            type: "string",
                        },
                        stateOrRegion: {
                            type: "string",
                        },
                        postalCode: {
                            type: "string",
                        },
                        countryCode: {
                            type: "string",
                        },
                        phoneNumber: {
                            type: "string",
                        },
                    }
                },
                "billingAddress": {
                    type: "object",
                    properties: {
                        name: {
                            type: "string",
                        },
                        addressLine1: {
                            type: "string",
                        },
                        addressLine2: {
                            type: "string",
                        },
                        addressLine3: {
                            type: "string",
                        },
                        city: {
                            type: "string",
                        },
                        county: {
                            type: "string",
                        },
                        district: {
                            type: "string",
                        },
                        stateOrRegion: {
                            type: "string",
                        },
                        postalCode: {
                            type: "string",
                        },
                        countryCode: {
                            type: "string",
                        },
                        phoneNumber: {
                            type: "string",
                        },
                    }
                }
            },
            required: ["paymentIntent"]
        }
    },
    required: ["pathParam"]
}

export default finalizeCheckoutSessionSchema